import React from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'
import { startsWithHttp } from 'helpers/strings'
import get from 'lodash.get'
import SVG from 'react-inlinesvg'

import Typography from 'components/atoms/Typography'
import CustomButton from 'components/atoms/CustomButton'
import LinkHandler from 'components/atoms/LinkHandler'

import './CardTopics.scss'

function CardTopics(props) {
  const color = get(props, 'color')
  const header = get(props, 'header')
  const topics = get(props, 'topics')
  const footer = get(props, 'footer')

  return (
    <div className={`CardTopics typeColor-${color}`}>
      <Typography variant="h3" component="h3" color={color}>
        {header}
      </Typography>
      <ul className="topics">
        {topics?.map((topic) => (
          <li className="topics__item" key={get(topic, 'key')}>
            {get(topic, 'icon') && (
              <div className="topics__icon">
                <SVG src={get(topic, 'icon')} />
              </div>
            )}
            <div className="topics__text">{ReactHtmlParser(get(topic, 'value'))}</div>
          </li>
        ))}
      </ul>

      {footer && (
        <LinkHandler to={get(footer, 'cta.url')}>
          <CustomButton
            color={color}
            className="mt-3"
            text={get(footer, 'cta.text', '')}
            iconAlign={get(footer, 'cta.iconAlign')}
            icon={startsWithHttp(get(footer, 'cta.url')) ? 'diagonal-arrow-right-up' : get(footer, 'cta.icon')}
          />
        </LinkHandler>
      )}
    </div>
  )
}

CardTopics.propTypes = {
  color: PropTypes.string,
  header: PropTypes.node,
  topics: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, value: PropTypes.string, icon: PropTypes.string })
  ),
  footer: PropTypes.object,
}

export default CardTopics
